var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{style:({ height: '50%' }),attrs:{"position":"bottom"},model:{value:(_vm.showPrick),callback:function ($$v) {_vm.showPrick=$$v},expression:"showPrick"}},[_c('van-picker',{attrs:{"show-toolbar":"","value-key":"name","columns":_vm.typeList},on:{"confirm":_vm.onConfirm,"cancel":_vm.onCancel,"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }